import { render } from "./CarTypeCard.vue?vue&type=template&id=acbbe770&scoped=true"
import script from "./CarTypeCard.vue?vue&type=script&lang=js"
export * from "./CarTypeCard.vue?vue&type=script&lang=js"

import "./CarTypeCard.vue?vue&type=style&index=0&id=acbbe770&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acbbe770"]])

export default __exports__